module.exports = __webpack_public_path__ + "img/made-au-bg2.44cccb7f.png";